import { CanDeactivateFn } from '@angular/router';
import { isAuthenticated } from '@features/auth/store/auth.signals';

export interface LeavablePage {
    canLeave(): Promise<boolean>;
}

export const analyticsLeaveGuard: CanDeactivateFn<LeavablePage> = component =>
    !isAuthenticated() || (component?.canLeave() ?? true);
